<script setup lang="ts">
  import { ref, computed } from "vue";
  import createJobStatusSetting from "@/types/requests/createJobStatusSetting"
  import createJobStatusFilterItems from "@/types/requests/createJobStatusFilterItems"
  import DownloadButton from "@/components/Files/DownloadButton"

  type Props = {
    showable: boolean;
    btnClass?: string;
    btnName?: string;
    type: string;
    operationOfficeId?: number;
    settings?: createJobStatusSetting;
    filterItems?: createJobStatusFilterItems;
    trips?: string[];
    disabled?: boolean;
    deliveryPlans?: Array<any>;
  };

  const props = withDefaults(defineProps<Props>(), {
    showable: false,
    disabled: false,
  });

  const getFilteredItems = () => {
    if (!props.deliveryPlans) return []

    const deliveryPlanIds = []
    props.deliveryPlans.forEach((v, i) => {
      deliveryPlanIds.push(v.delivery_plan_id)
    })
    return deliveryPlanIds
  }

  const addRequestParams = (params) => {
    if (!params.filter_items) params.filter_items = {}
    params.filter_items.delivery_plan_ids = getFilteredItems()
    return params
  }
</script>

<template>
  <DownloadButton
    v-show="props.showable"
    :class="props.btnClass"
    :disabled="props.disabled"
    :btnName="props.btnName"
    :type="props.type"
    :operationOfficeId="operationOfficeId"
    :settings="settings"
    :addRequestParams="addRequestParams"
  >
  </DownloadButton>
</template>
